import { WorldIcon } from "../Icons";
import { TooltipWrapper } from "../Tooltip";
import { Typo } from "../Typo";

export const ReferralLinksHeaderCell = ({ text }: { text: string }) => (
  <Typo type="bodyXS" textColor="text-text-secondary">
    {text}
  </Typo>
);

export const ReferralLinksDataCell = ({
  text,
  textColor,
  className,
}: {
  text?: string;
  textColor?: string;
  className?: string;
}) => (
  <Typo type="bodyMD" textColor={textColor} className={className}>
    {text ?? ""}
  </Typo>
);

export const ReferralLinksTooltipText = ({
  text,
  tooltipText,
}: {
  text?: string;
  tooltipText?: string;
}) => (
  <TooltipWrapper text={tooltipText ?? ""} color="blue" tooltipPlacement="top">
    <Typo type="bodyMD">{text ?? ""}</Typo>
  </TooltipWrapper>
);

export const TargetPageColumnCell = ({
  pageName,
  language,
}: {
  pageName?: string;
  language?: string;
}) => {
  const displayLanguage = (language ?? "").trim() || "All";

  return (
    <div className="flex h-[80px] min-w-0 flex-col justify-center gap-1 p-4">
      <Typo type="bodyMD" className="min-w-0">
        <span className="block truncate">{pageName ?? ""}</span>
      </Typo>
      <Typo
        type="bodySM"
        className="flex min-w-0 items-center gap-1 text-text-secondary"
      >
        <WorldIcon width={16} height={16} className="shrink-0" />
        <span className="truncate">{displayLanguage}</span>
      </Typo>
    </div>
  );
};

export const formatRebateProgram = (rebateProgram: string): string => {
  const raw = rebateProgram.trim();
  if (raw === "") return "";
  if (raw.toLowerCase().startsWith("hoid")) {
    return `HOID${raw.slice(4)}`;
  }
  return `HOID ${raw}`;
};
